import { NotifierService } from "angular-notifier";
import { Injectable } from "@angular/core";

@Injectable()
export class ToastService {
    constructor(private notifier: NotifierService) { }

    success(message: string) {
        this.notifier.notify('success', message);
    }
    error(message: string) {
        this.notifier.notify('error', message);
    }
    warning(message: string) {
        this.notifier.notify('warning', message);
    }
    info(message: string) {
        this.notifier.notify('info', message);
    }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/toast.service.ts